export const LOCALE_PREFIX = 'scenes.Gnosus.scenes.Report.components.Workspace.components.Blocks.Contracts'

export const CONTRACTS_TABLE_CHANGE = 'CONTRACTS_TABLE_CHANGE'
export const CONTRACTS_TABLE_DATA_RECEIVED = 'CONTRACTS_TABLE_DATA_RECEIVED'
export const CONTRACTS_TABLE_LOADING_TRUE = 'CONTRACTS_TABLE_LOADING_TRUE'
export const CONTRACTS_TABLE_LOADING_FALSE = 'CONTRACTS_TABLE_LOADING_FALSE'

export const CONTRACTS_TABLE_CHANGE_REQUEST = (id) => `CONTRACTS_${id}_TABLE_CHANGE_REQUEST`
